// extracted by mini-css-extract-plugin
export default {"button":"Button_button__4RHRH","button--log":"Button_button--log__uCt+t"};